module.exports = __webpack_public_path__ + "static/media/Tooth_icon_666666.867df258.svg";